module.exports = __webpack_public_path__ + "img/indus-pic-1.54cb1f2f.png";